import React, { useState, useEffect } from "react";
import ColorFieldComponent from "../../../Components/Forms/ColorFieldComponent";
import { ConeLogisticoConfiguracao } from "../../../Models/Paineis/ConeLogistico/ConeLogisticoConfiguracao";
import { ReactComponent as Cone } from "../../../Svgs/ConeLogistico/cone_logistico.svg";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";

const ConeLogisticoConfiguracaoCentralTab = (props: any) => {
    const [coneLogisticoConfiguracao, setConeConfiguracao] = useState<any>(new ConeLogisticoConfiguracao());

    useEffect(() => {
        setConeConfiguracao(props.coneLogisticoConfiguracao);
    }, [props.coneLogisticoConfiguracao]);

    const teste = 10;

    return (
        <div className="container">
            <div className="row" style={{ backgroundColor: '#888', paddingTop: '10px', paddingBottom: '0px', marginBottom: '0px' }}>
                <div className="row col-md-2">
                    <div className="col-md-12" style={{ marginBottom: '0px' }}>
                        <TextFieldComponent
                            label="Label Camadas 1"
                            field="label_camada_1"
                            id="label_camada_1"
                            textFieldChangedCallback={props.textFieldChangedCallback}
                            model={coneLogisticoConfiguracao}
                        />
                    </div>
                </div>
                <div className="row col-md-10" style={{ marginBottom: '0px' }}>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Camada 1"
                            field="cor_camada_1"
                            id="cor_camada_1"
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 1"
                            field="cor_interna_1_camada_1"
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 2"
                            field="cor_interna_2_camada_1"
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 3"
                            field="cor_interna_3_camada_1"
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Fundo Círculo"
                            field="fundo_circulo_camada_1"
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}   
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Fonte"
                            field="cor_fonte_camada_1"
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                </div>
            </div>

            <div className="row" style={{paddingTop: '10px', marginBottom: '0px', paddingBottom: '10px'}}>
                <div className="row col-md-2">
                    <div className="col-md-12" style={{ marginBottom: '0px' }}>
                        <TextFieldComponent
                            label="Label Camadas 2"
                            field='label_camada_2'
                            id='label_camada_2'
                            textFieldChangedCallback={props.textFieldChangedCallback}
                            model={coneLogisticoConfiguracao}
                        />
                    </div>
                </div>
                <div className="row col-md-10" style={{ marginBottom: '0px' }}>

                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Camada 2"
                            field='cor_camada_2'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 1"
                            field='cor_interna_1_camada_2'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 2"
                            field='cor_interna_2_camada_2'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 3"
                            field='cor_interna_3_camada_2'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Fundo Círculo"
                            field='fundo_circulo_camada_2'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Fonte"
                            field='cor_fonte_camada_2'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                </div>
            </div> 

            <div className="row" style={{ backgroundColor: '#888', paddingTop: '10px', paddingBottom: '0px', marginBottom: '0px' }}>
                <div className="row col-md-2">
                    <div className="col-md-12" style={{ marginBottom: '0px' }}>
                        <TextFieldComponent
                            label="Label Camadas 3"
                            field="label_camada_3"
                            id="label_camada_3"
                            textFieldChangedCallback={props.textFieldChangedCallback}
                            model={coneLogisticoConfiguracao}
                        />
                    </div>
                </div>
                <div className="row col-md-10" style={{ marginBottom: '0px' }}>
                    <div className="col-md-2">

                        <ColorFieldComponent
                            label="Cor Camada 3"
                            field='cor_camada_3'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 1"
                            field='cor_interna_1_camada_3'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 2"
                            field='cor_interna_2_camada_3'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 3"
                            field='cor_interna_3_camada_3'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Fundo Círculo"
                            field='fundo_circulo_camada_3'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Fonte"
                            field='cor_fonte_camada_3'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                </div>
            </div>

            <div className="row" style={{paddingTop: '10px', marginBottom: '0px',  paddingBottom: '0px'}}>
                <div className="row col-md-2">
                    <div className="col-md-12" style={{ marginBottom: '0px' }}>
                        <TextFieldComponent
                            label="Label Camadas 4"
                            field='label_camada_4'
                            id='label_camada_4'
                            textFieldChangedCallback={props.textFieldChangedCallback}
                            model={coneLogisticoConfiguracao}
                        />
                    </div>
                </div>
                <div className="row col-md-10" style={{ marginBottom: '0px' }}>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Camada 4"
                            field='cor_camada_4'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 1"
                            field='cor_interna_1_camada_4'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 2"
                            field='cor_interna_2_camada_4'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 3"
                            field='cor_interna_3_camada_4'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Fundo Círculo"
                            field='fundo_circulo_camada_4'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Fonte"
                            field='cor_fonte_camada_4'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                </div>
            </div>

            <div className="row" style={{ backgroundColor: '#888', paddingTop: '10px', paddingBottom: '0px', marginBottom: '0px' }}>
                <div className="row col-md-2">
                    <div className="col-md-12" style={{ marginBottom: '0px' }}>
                        <TextFieldComponent
                            label="Label Camadas 5"
                            field="label_camada_5"
                            id="label_camada_5"
                            textFieldChangedCallback={props.textFieldChangedCallback}
                            model={coneLogisticoConfiguracao}
                        />
                    </div>
                </div>
                <div className="row col-md-10" style={{ marginBottom: '0px' }}>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Camada 5"
                            field='cor_camada_5'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 1"
                            field='cor_interna_1_camada_5'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 2"
                            field='cor_interna_2_camada_5'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 3"
                            field='cor_interna_3_camada_5'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Fundo Círculo"
                            field='fundo_circulo_camada_5'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Fonte"
                            field='cor_fonte_camada_5'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                </div>
            </div>

            <div className="row" style={{paddingTop: '10px', marginBottom:'0px'}}>
                <div className="row col-md-2">
                    <div className="col-md-12" style={{ marginBottom: '0px' }}>
                        <TextFieldComponent
                            label="Label Camadas 6"
                            field="label_camada_6"
                            id="label_camada_6"
                            textFieldChangedCallback={props.textFieldChangedCallback}
                            model={coneLogisticoConfiguracao}
                        />
                    </div>
                </div>
                <div className="row col-md-10" style={{ marginBottom: '0px' }}>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Camada 6"
                            field='cor_camada_6'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 1"
                            field='cor_interna_1_camada_6'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 2"
                            field='cor_interna_2_camada_6'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 3"
                            field='cor_interna_3_camada_6'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Fonte"
                            field='cor_fonte_camada_6'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                </div>
            </div>
            
            <div className="row" style={{ backgroundColor: '#888', paddingTop: '10px', paddingBottom: '0px', marginBottom: '0px' }}>
                <div className="row col-md-2">
                    <div className="col-md-12" style={{ marginBottom: '0px' }}>
                        <TextFieldComponent
                            label="Label Camadas 7"
                            field="label_camada_7"
                            id="label_camada_7"
                            textFieldChangedCallback={props.textFieldChangedCallback}
                            model={coneLogisticoConfiguracao}
                        />
                    </div>
                </div>
                <div className="row col-md-10" style={{ marginBottom: '0px' }}>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Camada 7"
                            field='cor_camada_7'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 1"
                            field='cor_interna_1_camada_7'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Interna 2"
                            field='cor_interna_2_camada_7'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                    <div className="col-md-2">
                        <ColorFieldComponent
                            label="Cor Fonte"
                            field='cor_fonte_camada_7'
                            model={coneLogisticoConfiguracao}
                            colorChangedCallback={props.colorChangedCallback}  
                        />
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-6 mb-6">
                    <Cone />
                </div>
            </div>
        </div>
    );
}

export default ConeLogisticoConfiguracaoCentralTab;